import React from 'react';
import { ServiceFeaturesGrid } from '../common/service-features-grid';

export function SimproServies() {
    const features = [
        {
            title: 'Workflow Customization',
            description:
                'Tailor simPRO\'s workflows to match your specific business processes. Our custom simPRO development services allow you to create custom stages, steps, and automation rules that reflect your unique service delivery model. Streamline your workflows and optimize efficiency with customized workflows.',
            icon: '/img/technology/ic-workflow.svg',
        },
        {
            title: 'Integration Services',
            description:
                'Seamlessly integrate simPRO with other business apps to ensure smooth data flow and eliminate manual data entry. Our developers can integrate simPRO with your existing CRM, project management tools, or software. Experience a unified view of your operations and streamline information exchange across systems.',
            icon: '/img/technology/ic-integration.svg',
        },
        {
            title: 'Custom Reporting and Analytics',
            description:
                'Gain valuable insights into your business performance with custom reporting and analytics solutions. Our custom simPRO development team can create comprehensive reports and interactive dashboards tailored to your KPIs. Leverage data-driven decision-making and drive growth with powerful analytics.',
            icon: '/img/technology/ic-reporting.svg',
        },
        {
            title: 'Mobile App Development',
            description:
                'Bring simPRO to your fingertips with a custom mobile app tailored to your needs. Access its features and functionality on the go, ensuring you have the right tools at the right time and place. Embrace the convenience of a mobile app that maximizes your field service management capabilities.',
            icon: '/img/technology/ic-mobile-app.svg',
        },
        {
            title: 'API Development and Integration',
            description:
                'Our experts specialize in creating custom APIs to seamlessly connect simPRO with other applications, enabling automated workflows, synchronized data, and improved operational efficiency. We ensure smooth data exchange, eliminating manual data entry and enhancing overall productivity.',
            icon: '/img/technology/ic-api.svg',
        },
        {
            title: 'Bespoke Module Development',
            description:
                'Expand simPRO\'s capabilities with bespoke module development. Whether you require specialized quoting and invoicing processes, unique inventory management functionalities, or industry-specific modules, we can build custom solutions to enhance simPRO\'s functionality.',
            icon: '/img/technology/ic-bespoke-module.svg',
        },
    ];

    return (
        <>
            <div className="section-py bg-grey dark:bg-black">
                <div className="container lg:container mx-auto">
                    <div className="row grid lg:grid-cols-12">
                        <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                            <p
                                className="text-primary mb-0 fs-lg fw-700"
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="200"
                            >
                                We Provide
                            </p>
                            <h2
                                data-aos="fade-up"
                                data-aos-duration="700"
                                data-aos-delay="100"
                            >
                                Custom simPRO Development Services
                            </h2>
                        </div>
                    </div>
                <ServiceFeaturesGrid features={features} variant="grey" />
                </div>
            </div>
        </>
    );
}

export default SimproServies;